// extracted by mini-css-extract-plugin
export default {"avatar":"profile_avatar__FlzFC","profile-dropdown":"profile_profile-dropdown__yHwoh","submit-button":"profile_submit-button__R-+KZ"};